import React, { useEffect, useState } from "react";

import { Row, Col, Typography, Input, Tag, Menu, Dropdown, Icon, Button, Modal, Select, message, Table, Pagination } from "antd";
// import "./SharePoint.scss";
import moment from "moment";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ReactComponent as FamilyLogo } from "./images/familyLogo.svg";
import { ReactComponent as OthersLogo } from "./images/othersLogo.svg";
import { ReactComponent as FreindsLogo } from "./images/freindsLogo.svg";
import { fetchCohortAdminListApi, fetchSharePointsAdminRecentTxnsApi } from "utils/apiService";

import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-community/index.css";

const { Text } = Typography;
const { Option } = Select;

const makeCaptial = (str) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};
const formatDate = (date, from, to) => {
	var newDate = date ? new moment(date, from) : new moment();

	return newDate.format(to);
};
const RecentTransactionsTable = (props) => {
	const { data } = props;
	const TempColumns = [
		{ title: "Name", width: 250 },
		{
			title: "Age",
			width: 100,
			// icon: GridColumnIcon.HeaderNumber,
			themeOverride: {
				bgIconHeader: "#00967d",
				textDark: "#00c5a4",
				textHeader: "#00c5a4",
			},
		},
		{ title: "Avatar", width: 80 },
	];

	const columns = [
		{
			title: "Sender",
			dataIndex: ["sender_full_name", "sender_contact_number"],
			key: "Sender",
			render: (_, data) => {
				return (
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Text
							style={{
								fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "16px",
								lineHeight: "24px",
								color: "#181818",
								// whiteSpace: "nowrap",
							}}>
							{data.sender_full_name ? data.sender_full_name : "Unknown"}
						</Text>
						<Text
							style={{
								fontStyle: "normal",
								fontSize: "16px",
								lineHeight: "24px",
								color: "#747474",
								whiteSpace: "nowrap",
							}}>
							{data.sender_contact_number ? data.sender_contact_number : "+931-888888888"}
						</Text>
					</div>
				);
			},
		},
		{
			title: "Receiver",
			dataIndex: ["receiver_full_name", "receiver_contact_number"],
			key: "Receiver",
			render: (_, data) => {
				return (
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Text
							style={{
								fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "16px",
								lineHeight: "24px",
								color: "#181818",
								// whiteSpace: "nowrap",
							}}>
							{data.receiver_full_name ? data.receiver_full_name : "Unknown"}
						</Text>
						<Text
							style={{
								fontStyle: "normal",
								fontSize: "16px",
								lineHeight: "24px",
								color: "#747474",
								whiteSpace: "nowrap",
							}}>
							{data ? data.receiver_contact_number : "+931-888888888"}
						</Text>
					</div>
				);
			},
		},
		{
			title: "Points",
			dataIndex: "points_shared",
			// sorter: (a, b) => {
			//   return b.points_shared - a.points_shared;
			//   // multiple: 1,
			// },
			// defaultSortOrder: "descend",
			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data ? data : "50000"}
					</Text>
				);
			},
		},
		{
			title: "Transaction Id",
			dataIndex: "txn_number",
			key: "Transaction_Id",

			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data ? data : "123456789"}
					</Text>
				);
			},
		},
		{
			title: "Type",
			dataIndex: "relation_type",
			key: "Type",
			render: (data) => {
				data = data.toLowerCase();
				return (
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							width: "78px",
							border: "none",
							background: `${"others" === data ? "#FFFADD" : data === "family" ? "#F5E6FE" : "#E3F8FA"}`,
							padding: "1px 8px",
						}}>
						{data === "others" ? (
							<OthersLogo className="typeTag" />
						) : data === "family" ? (
							<FamilyLogo className="typeTag" />
						) : (
							<FreindsLogo className="typeTag" />
						)}
						<Text
							style={{
								fontStyle: "normal",
								fontWeight: "normal",
								fontSize: "12px",
								lineHeight: "20px",
								color: `${"others" === data ? "#CCAE00" : data === "family" ? "#BE63F9" : "#26C6DA"}`,
								marginLeft: "4px",
							}}>
							{data ? makeCaptial(data) : "Freinds"}
						</Text>
					</div>
				);
			},
		},
	];
	return (
		<>
			<Table
				height={500}
				// scroll={{ y: 300 }}
				sticky
				// rowSelection={props.noAction ? null : rowSelection}
				columns={(function () {
					// if (props.noAction) {
					// 	return columns.filter((item) => item.key != "x");
					// }
					return columns;
				})()}
				dataSource={data?.transaction_list}
				pagination={{
					showQuickJumper: true,
					pageSize: 10,
					total: props.data?.total_pages * 10,
					defaultCurrent: props.pageNum,
					onChange: (page) => {
						props.setPageNum(page);
					},
				}}
				style={{ overflow: "visible" }}
				loading={props.loading}
			/>
			{/* <DataEditorContainer
        width={1000}
        height={700}
        // style={{ background: "red" }}
      >
        <DataEditor
          // dataSource={[
          //   { Name: 10, Age: 10, Avtar: 12 },
          //   { Name: 10, Age: 10, Avtar: 12 },
          // ]}
          columns={TempColumns}
        />
      </DataEditorContainer> */}
		</>
	);
};
const RecentTransactions = (props) => {
	const [pageNum, setPageNum] = useState({
		success: 1,
		failed: 1,
		pending: 1,
	});
	const [activeTab, setActiveTab] = useState("success");
	const [searchKey, setSearchKey] = useState("");
	const [tableLoading, setTableLoading] = useState(true);
	const [transactions, setTransactions] = useState([]);
	const [sortBy, setSortBy] = useState("original");
	const columns = [
		{
			name: "name",
			header: "Name",
			minWidth: 50,
			defaultFlex: 2,
			filer: "false",
		},
		{ name: "age", header: "Age", maxWidth: 1000, defaultFlex: 1 },
	];

	const gridStyle = { minHeight: 550 };

	const dataSource = [
		{ id: 1, name: "John McQueen", age: 35 },
		{ id: 2, name: "Mary Stones", age: 25 },
		{ id: 3, name: "Robert Fil", age: 27 },
		{ id: 4, name: "Roger Robson", age: 81 },
		{ id: 5, name: "Billary Konwik", age: 18 },
		{ id: 6, name: "Bob Martin", age: 18 },
		{ id: 7, name: "Matthew Richardson", age: 54 },
		{ id: 8, name: "Ritchie Peterson", age: 54 },
		{ id: 9, name: "Bryan Martin", age: 40 },
		{ id: 10, name: "Mark Martin", age: 44 },
		{ id: 11, name: "Michelle Sebastian", age: 24 },
		{ id: 12, name: "Michelle Sullivan", age: 61 },
		{ id: 13, name: "Jordan Bike", age: 16 },
		{ id: 14, name: "Nelson Ford", age: 34 },
		{ id: 15, name: "Tim Cheap", age: 3 },
		{ id: 16, name: "Robert Carlson", age: 31 },
		{ id: 17, name: "Johny Perterson", age: 40 },
	];
	const [data, setData] = useState(dataSource);
	const onEditComplete =
		(({ value, columnId, rowIndex }) => {
			const tempdata = [...data];
			tempdata[rowIndex][columnId] = value;

			setData(data);
		},
		[data]);
	const loadTable = () => {
		setTableLoading(true);
		fetchSharePointsAdminRecentTxnsApi({
			requestData: {
				start_date: formatDate(props.range.start_date, "YYYY-MM-DD", "DD-MM-YYYY"),
				end_date: formatDate(props.range.end_date, "YYYY-MM-DD", "DD-MM-YYYY"),
				search_term: searchKey,
				page_number: pageNum,
				sort_by: {
					key: sortBy === "original" ? "date_created" : "points_shared",
					order: sortBy === "points-high-low" ? "-" : "",
				},
			},
			res200Callback: (res) => {
				// message.success(JSON.stringify(res.data));
				setTransactions(res.data);
			},
			resCallback: (res) => {
				setTableLoading(false);
			},
		});
	};
	useEffect(() => {
		loadTable();
	}, [searchKey, props, pageNum, sortBy]);
	return (
		<div style={{ marginTop: "32px" }}>
			<Row type="flex" align="middle" justify="space-between">
				<Text
					style={{
						color: "#181818",
						fontStyle: "normal",

						fontWeight: "bold",
						fontSize: "20px",
						lineHeight: "32px",
					}}>
					All Transactions
				</Text>
				<div style={{ display: "flex", alignItems: "center" }}>
					<Input
						style={{
							marginTop: "2px",
							marginRight: "8px",
							height: "40px",
							width: "220px",
							borderRadius: "5px",
						}}
						value={searchKey}
						placeholder="Search"
						onChange={(e) => {
							setSearchKey(e.target.value);
							// console.log(e.target.value);
							//   loadTable(e.target.value);
						}}
						prefix={<Icon type="search" />}
						// bordered={true}
					/>
					<Select
						className="SharePointSort"
						style={{
							width: "170px",
							padding: "4px",
							height: "40px",
							borderRadius: "5px",
							color: "#A3A3A3",
							border: "1px solid #D9D9D9",
						}}
						value={sortBy}
						onChange={(value) => {
							setSortBy(value);
							// let tempTransactions = [...transactions];
							// if (value == "points-low-high" || value == "points-high-low") {
							// 	setTableLoading(true);
							// 	await tempTransactions.success.sort((a, b) => {
							// 		return a.points_shared - b.points_shared;
							// 	});
							// 	await tempTransactions.pending.sort((a, b) => {
							// 		return a.points_shared - b.points_shared;
							// 	});
							// 	await tempTransactions.failed.sort((a, b) => {
							// 		return a.points_shared - b.points_shared;
							// 	});
							// 	if (value == "points-high-low") {
							// 		await tempTransactions.success.reverse();
							// 		await tempTransactions.pending.reverse();
							// 		await tempTransactions.failed.reverse();
							// 	}
							// 	// setSortedTransactions(tempTransactions);
							// 	setTableLoading(false);
							// } else {
							// 	setTableLoading(true);
							// 	// setSortedTransactions(transactions);
							// 	loadTable();
							// }
						}}
						placeholder="Sort By"
						showSearch>
						<Option value={"points-low-high"}>Points (Low to High)</Option>

						<Option value={"points-high-low"} alt="points-high-low">
							Points (High to Low)
						</Option>

						<Option value="original">Original</Option>
						{/* <Option value={"Time"}>Time</Option> */}
					</Select>
				</div>
			</Row>
			{!tableLoading && (
				<Menu
					selectedKeys={activeTab}
					onSelect={(e) => setActiveTab(e.key)}
					mode="horizontal"
					style={{ backgroundColor: "transparent", marginTop: "16px" }}>
					<Menu.Item key="success" style={{ fontWeight: `${activeTab === "success" ? "bold" : ""}` }}>
						{/* <Link to={`${url}`}> */}
						Success {`(${transactions.success?.total_transactions || 0})`}
						{/* </Link> */}
					</Menu.Item>
					<Menu.Item key="pending" style={{ fontWeight: `${activeTab === "pending" ? "bold" : ""}` }}>
						{/* <Link to={`${url}/archived`}> */}
						Pending {`(${transactions.pending?.total_transactions || 0})`}
						{/* </Link> */}
					</Menu.Item>
					<Menu.Item key="failed" style={{ fontWeight: `${activeTab === "failed" ? "bold" : ""}` }}>
						{/* <Link to={`${url}/archived`}> */}
						Failed {`(${transactions.failed?.total_transactions || 0})`}
						{/* </Link> */}
					</Menu.Item>
				</Menu>
			)}
			<RecentTransactionsTable
				{...props}
				loading={tableLoading}
				// setTableLoading = {set}
				setPageNum={(page) =>
					setPageNum({
						...pageNum,
						success: activeTab === "success" ? page : pageNum.success,
						pending: activeTab === "pending" ? page : pageNum.pending,
						failed: activeTab === "failed" ? page : pageNum.failed,
					})
				}
				pageNum={activeTab === "success" ? pageNum.success : activeTab === "pending" ? pageNum.pending : pageNum.failed}
				data={activeTab === "success" ? transactions.success : activeTab === "pending" ? transactions.pending : transactions.failed}
			/>
			{/* <ReactDataGrid
        filterable={false}
        style={{ width: "auto" }}
        columns={columns}
        dataSource={data}
        onEditComplete={onEditComplete}
        editable={true}
        onColumnResize={({ column, size }) => {
          console.log(column, size);
        }}
      ></ReactDataGrid> */}
		</div>
	);
};

export default RecentTransactions;
